import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 cursor-not-allowed"
}
const _hoisted_2 = { class: "flex flex-col items-center justify-center text-white" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!

  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_ProgressSpinner, {
            style: {"width":"60px","height":"60px"},
            strokeWidth: "5",
            fill: "transparent",
            animationDuration: ".5s"
          }),
          _cache[0] || (_cache[0] = _createElementVNode("span", null, "Procesando...", -1))
        ])
      ]))
    : _createCommentVNode("", true)
}